import { createActionTypes } from "@helpers/redux-helpers";

export const getLikesListActionTypes = createActionTypes("likesList/get");

export const getLikesListPortionActionTypes = createActionTypes(
  "likesList/get/portion",
);
